/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskOverviewTimeSeriesFinding = {
  /**
   * Time bucket start.
   */
  bucketStart: Date;
  /**
   * Policy category key.
   */
  category: string;
  /**
   * Finding count for this category and time bucket.
   */
  findings: number;
};

/** @internal */
export const RiskOverviewTimeSeriesFinding$inboundSchema: z.ZodMiniType<
  RiskOverviewTimeSeriesFinding,
  unknown
> = z.pipe(
  z.object({
    bucket_start: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    category: z.string(),
    findings: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bucket_start": "bucketStart",
    });
  }),
);

export function riskOverviewTimeSeriesFindingFromJSON(
  jsonString: string,
): SafeParseResult<RiskOverviewTimeSeriesFinding, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskOverviewTimeSeriesFinding$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskOverviewTimeSeriesFinding' from JSON`,
  );
}
